import { toast } from "sonner";
import { useTranslation } from 'react-i18next';
import { useMutation } from "@tanstack/react-query";
import { ErrorUtils } from "@edutrackr/shared/utils";
import { TeacherMutationKeys } from "@edutrackr/shared/enums";
import { GetAssistantAnswerRequest } from "@edutrackr/services/common";
import { commonAssistantService } from "../../../shared/services";

export const useAssistantAnswerMutation = () => {
  const { t } = useTranslation('sessions', {
    keyPrefix: 'hooks.useAssistantAnswerMutation',
  });
  const assistantAnswerMutation = useMutation({
    mutationKey: [TeacherMutationKeys.GetAssistantAnswer as const],
    mutationFn: async (request: GetAssistantAnswerRequest) => {
      return await commonAssistantService.getAssistantAnswer(request);
    },
    onSuccess: data => {
      // toast.success(data.message);
    },
    onError: e => {
      const errorDetail = ErrorUtils.getErrorDetail(e);
      toast.error(t('error.title'), {
        description: errorDetail.message
      });
    },
  });

  return assistantAnswerMutation;
}
